import { proxy } from "valtio";
export const errorHandling = proxy({
    set: (config) => {
        Object.assign(errorHandling, config);
    },
});
